import { BasicInformationM } from '@interfaces/basic-profileI';
import { PractitionerData } from '@interfaces/organizationI';
import { ConsultingRoomsI, ServicesI } from '@interfaces/search';
import { ReasonI } from '@interfaces/services/services';
import { AppointmentForm } from '@modules/practitioner/patients/schedule-appointment/appointment-data';
import { PatientForm } from '@modules/practitioner/patients/schedule-appointment/patient-data';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface IAppointment
{
    office: ConsultingRoomsI,
    service: ServicesI,
    reason: ReasonI,
    practitioner: PractitionerData
}

interface AppointmentSlice 
{
    patient: BasicInformationM;
    patientForm: PatientForm;
    appointment: IAppointment,
    appointmentForm: AppointmentForm
}

export const createAppointment = createSlice({
    name: 'create-appointment',
    initialState: {} as unknown as AppointmentSlice,
    reducers: {
        setPatientInformation: (state, action: PayloadAction<{ form: PatientForm, patient: BasicInformationM }>) => {
            state.patientForm = action.payload.form;
            state.patient = action.payload.patient;
        },
        setAppointmentInfo: (state, action: PayloadAction<{ form: AppointmentForm, appointment: { office: ConsultingRoomsI, service: ServicesI, reason: ReasonI, practitioner: PractitionerData} }>) => {
            state.appointmentForm = {...action.payload.form};
            state.appointment = {...action.payload.appointment}
        },
        cleanInfo: (state) => {
            state.appointment = {} as IAppointment;
            state.appointmentForm = {} as AppointmentForm;
            state.patient = {} as BasicInformationM;
            state.patientForm = {} as PatientForm
        },
    },
});

export const { setPatientInformation, setAppointmentInfo, cleanInfo } = createAppointment.actions;
export default createAppointment.reducer;